import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@navfleet/client/authentication/effects';
import { LoginContainer } from '@navfleet/client/authentication/feature';
import { getNavRoutePartialRoute } from '@navfleet/client/navigation/domain/data-access';
import { NAV_ROUTES } from '@navfleet/client/navigation/domain/models';
import { ToasterService } from '@navfleet/client/shared/services/toast';
import { PageNotFoundComponent } from '@navfleet/client/shared/ui/page-not-found';
import { LayoutContainer } from '@navfleet/client/shell/feature/layout';

const routes: Routes = [
    {
        ...getNavRoutePartialRoute(NAV_ROUTES.LOGIN),
        component: LoginContainer,
    },
    {
        ...getNavRoutePartialRoute(NAV_ROUTES.MANUAL),
        loadComponent: () => import('@navfleet/client/discover/manual/feature').then((f) => f.DiscoverManualContainer),
    },
    {
        ...getNavRoutePartialRoute(NAV_ROUTES.DASHBOARD),
        providers: [ToasterService],
        loadChildren: () => import('@navfleet/client/dashboard/feature').then((f) => f.DASHBOARD_ROUTES),
    },
    {
        path: '',
        canActivate: [AuthenticationGuard],
        component: LayoutContainer,
        children: [
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.FLEET),
                loadChildren: () => import('@navfleet/client/fleet/feature/shell').then((f) => f.FLEET_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.VESSEL),
                loadChildren: () => import('@navfleet/client/vessel/shell/feature/shell').then((f) => f.VESSEL_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.PASSAGES),
                loadChildren: () => import('@navfleet/client/passage/feature').then((f) => f.PASSAGE_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.PORTS),
                loadChildren: () => import('@navfleet/client/port/feature/shell').then((f) => f.PORTS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.DOCUMENTS),
                loadChildren: () => import('@navfleet/client/document/feature/shell').then((f) => f.DOCUMENTS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.LOGBOOK_ANALYTICS),
                loadChildren: () =>
                    import('@navfleet/client/logbook-analytics/feature').then((f) => f.LOGBOOK_ANALYTICS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.EMISSIONS),
                loadChildren: () => import('@navfleet/client/emissions/feature').then((f) => f.EMISSIONS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.PORT_STATE_CONTROL),
                loadChildren: () =>
                    import('@navfleet/client/port-state-control/feature/shell').then(
                        (f) => f.PORT_STATE_CONTROLS_ROUTES
                    ),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.TIERS),
                loadChildren: () => import('@navfleet/client/tiers/feature/shell').then((f) => f.TIERS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.DISCOVER),
                loadChildren: () =>
                    import('@navfleet/client/discover/main/feature/shell').then((f) => f.DISCOVERS_ROUTES),
            },
            {
                ...getNavRoutePartialRoute(NAV_ROUTES.SETTINGS),
                loadChildren: () => import('@navfleet/client/settings/feature').then((f) => f.SETTINGS_ROUTES),
            },
            {
                path: '**',
                component: PageNotFoundComponent,
            },
        ],
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: NAV_ROUTES.LOGIN.path,
    },
];

const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always',
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routingConfiguration)],
    exports: [RouterModule],
})
export class ClientShellRoutingModule {}
